import type { auditReports } from '@mi-front/api-clients';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

interface StringColumnConfigEditorProps {
  config: auditReports.StringColumnConfigDto;
  onTypeChange: (config: auditReports.StringColumnConfigDto) => void;
}

export function StringColumnConfigEditor({ config, onTypeChange }: StringColumnConfigEditorProps) {
  const { $t } = useIntl();

  const handleCaseChange = (caseValue: auditReports.StringColumnConfigDtoCaseEnumKey | null) => {
    onTypeChange({
      ...config,
      case: caseValue || null,
    });
  };

  return (
    <Box marginTop={2}>
      <FormControl size="small">
        <Typography variant="caption" color="text.secondary" gutterBottom>
          {$t({
            id: 'audit.reportDefinitionEditor.columnType.string.case',
            defaultMessage: 'Formato de texto',
          })}
        </Typography>
        <Select
          value={config.case || ''}
          onChange={(e) =>
            handleCaseChange(
              (e.target.value || null) as auditReports.StringColumnConfigDtoCaseEnumKey | null,
            )
          }
          displayEmpty
        >
          <MenuItem value="">
            <em>
              {$t({
                id: 'audit.reportDefinitionEditor.columnType.string.case.none',
                defaultMessage: 'Sin formato',
              })}
            </em>
          </MenuItem>
          <MenuItem value="uppercase">
            {$t({
              id: 'audit.reportDefinitionEditor.columnType.string.case.uppercase',
              defaultMessage: 'Mayúsculas',
            })}
          </MenuItem>
          <MenuItem value="lowercase">
            {$t({
              id: 'audit.reportDefinitionEditor.columnType.string.case.lowercase',
              defaultMessage: 'Minúsculas',
            })}
          </MenuItem>
          <MenuItem value="title">
            {$t({
              id: 'audit.reportDefinitionEditor.columnType.string.case.title',
              defaultMessage: 'Título',
            })}
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
